import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { ContactService } from 'src/app/services/contact.service';
import { ContractService } from 'src/app/services/contract.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  /**
   * The Templates to be send
   */
  templates: Array<any> = [];
  /**
   * The ID of the currentUser => set via URL
   */
  userID:string = "";
  /**constructor
   * 
   * @param route 
   * @param contactService 
   */
  constructor(
    private route:ActivatedRoute,
    private contactService:ContactService,
    private overlayService:OverlayService){

  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.userID = params['id'];
      combineLatest([
        this.contactService.getAllTempaltes(params['id']),   
      ]).subscribe({
        next : (res:Array<any>) =>{
          this.templates = res[0];
        },
        error : err =>{
          console.log(err)
        }
      })
    })
  }
  /**
   * Send a Notification to the Contractholder
   * @param template 
   */
  sendNotification(template){
    this.contactService.sendNotification(this.userID,template).subscribe({
      next : (res:Array<any>) =>{
        this.overlayService.openSnackBar("Mail erfolgreich gesendet!", "success", 5000)
      },
      error : err =>{
        console.log(err)
      }
    })
  }
 
}
